'use client';
const deriveBaseShades = (color)=>{
    return {
        min: {
            day: color[50],
            night: color[950]
        },
        mid: {
            day: color[200],
            night: color[920]
        },
        base: {
            day: color[600],
            night: color[800]
        },
        big: {
            day: color[800],
            night: color[600]
        },
        max: {
            day: color[900],
            night: color[200]
        }
    };
};

export { deriveBaseShades };
//# sourceMappingURL=deriveBaseShades.js.map
